import { ResponsiveLine } from "@nivo/line";
import { useTheme } from "@mui/material";

const LineChart = ({ data, isCustomLineColors = false, isDashboard = false }) => {
  const theme = useTheme();
  const colors = theme.palette.mode === "dark" 
    ? {
        grey: { 100: "#e0e0e0", 200: "#c2c2c2" },
        primary: { 500: "#1e293b" },
        greenAccent: { 500: "#4caf50" },
      }
    : {
        grey: { 100: "#333333", 200: "#4f4f4f" },
        primary: { 500: "#ffffff" },
        greenAccent: { 500: "#388e3c" },
      };

  if (!data || !Array.isArray(data) || data.length === 0 || !data[0]?.data?.length) {
    return (
      <div
        style={{
          padding: "20px",
          textAlign: "center",
          color: colors.grey[100],
          fontSize: "14px",
          fontWeight: 600,
        }}
      >
        Aucune donnée de marques disponible
      </div>
    );
  }

  return (
    <ResponsiveLine
      data={data}
      theme={{
        background: "transparent",
        axis: {
          domain: { line: { stroke: colors.grey[100] } },
          legend: { text: { fill: colors.grey[100], fontSize: 12 } },
          ticks: {
            line: { stroke: colors.grey[100], strokeWidth: 1 },
            text: { fill: colors.grey[100], fontSize: 12 },
          },
        },
        legends: { text: { fill: colors.grey[100], fontSize: 13 } },
        tooltip: {
          container: {
            background: colors.primary[500],
            color: colors.grey[100],
            fontSize: "14px",
            borderRadius: "4px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
            padding: "8px 12px",
          },
        },
      }}
      colors={isCustomLineColors ? { datum: "color" } : { scheme: "nivo" }}
      margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
      xScale={{ type: "point" }}
      yScale={{
        type: "linear",
        min: "auto",
        max: "auto",
        stacked: false,
        reverse: false,
      }}
      curve="catmullRom"
      axisTop={null}
      axisRight={null}
      axisBottom={{
        orient: "bottom",
        tickSize: 5,
        tickPadding: 5,
        tickRotation: data[0].data.length > 5 ? 45 : 0,
        legend: isDashboard ? undefined : "Zone de protection",
        legendOffset: 36,
        legendPosition: "middle",
      }}
      axisLeft={{
        orient: "left",
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: isDashboard ? undefined : "Nombre de marques",
        legendOffset: -50,
        legendPosition: "middle",
      }}
      enableGridX={false}
      enableGridY={true}
      enablePoints={true}
      pointSize={10}
      pointColor={{ theme: "background" }}
      pointBorderWidth= {2}
      pointBorderColor={{ from: "serieColor" }}
      pointLabel="y"
      pointLabelYOffset={-12}
      useMesh={true}
      tooltip={({ point }) => (
        <div
          style={{
            background: colors.primary[500],
            padding: "8px 12px",
            borderRadius: "4px",
            color: colors.grey[100],
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
            fontSize: "14px",
          }}
        >
          <strong>Zone:</strong> {point.data.x}<br />
          <strong>Marques:</strong> {point.data.y}
        </div>
      )}
      legends={
        isDashboard
          ? []
          : [
              {
                anchor: "bottom-right",
                direction: "column",
                justify: false,
                translateX: 100,
                translateY: 0,
                itemsSpacing: 2,
                itemWidth: 100,
                itemHeight: 20,
                itemOpacity: 0.85,
                symbolSize: 12,
                symbolShape: "circle",
                effects: [
                  {
                    on: "hover",
                    style: { itemOpacity: 1 },
                  },
                ],
              },
            ]
      }
      role="application"
      ariaLabel={(point) => `Zone: ${point.data.x}, Marques: ${point.data.y}`}
    />
  );
};

export default LineChart;